import { Box } from '@mui/material';
import React from 'react';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import {
  ApproachSection,
  CollectiveSection,
  ContactSectionWrapper,
  EBooksSection,
  FooterSection,
  ServicesSection,
} from '../components/organisms';
import {
  RsmcBadgesStrip,
  RsmcPillarsSection,
  RsmcPillarsStrip,
} from '../components/RsmcPillars';
import { hero } from '../data/homepage';
import { useScrollToSection } from '../hooks/useScrollToSection';

/**
 * Home page component that contains the main landing page sections
 *
 * This component follows atomic design principles:
 * - Uses custom hook for scroll functionality
 * - Delegates section rendering to organism components
 * - Maintains clean separation of concerns
 * - Single responsibility: orchestrate the homepage layout
 *
 * @returns {React.ReactElement} The home page layout
 */
function HomePage() {
  const { refs, scrollFunctions } = useScrollToSection();

  return (
    <Box sx={{ textAlign: 'left' }}>
      <Header
        scrollToCollective={scrollFunctions.scrollToCollective}
        scrollToServices={scrollFunctions.scrollToServices}
        scrollToContact={scrollFunctions.scrollToContact}
      />
      <HeroSection title={hero.title} subtitle={hero.subtitle} />

      <RsmcPillarsStrip />
      <RsmcPillarsSection />
      <RsmcBadgesStrip />

      <ServicesSection sectionRef={refs.servicesRef} />
      <CollectiveSection sectionRef={refs.collectiveRef} />
      <EBooksSection />
      <ApproachSection />
      <ContactSectionWrapper sectionRef={refs.contactRef} />
      <FooterSection />
    </Box>
  );
}

export default HomePage;
